// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__xub8j","rotation":"SmallLoader_rotation__OvroP"};